module.exports = __webpack_public_path__ + "static/img/contant_3.d524a50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_12/contant_3.jpg
// module id = PfIs
// module chunks = 0